//// sidebar
(function($, window, undefined) {

  var defaults = {}

  function wbskSideBar(element,settings) {
    this.sidebar = $(element)
    this.openCtrlr = settings.openCtrlr
    this.closeCtrlr = this.sidebar.find('.wbsk-ui-sidebar__close')
    this.container = this.sidebar.find('.wbsk-ui-sidebar__container')
    this.init()
  }

  wbskSideBar.prototype = {
    init: function() {      
      var _this = this
      
      //bind handlers
      this.openCtrlr.on('click', function(e) {
        e.preventDefault()
        let $button = $(e.currentTarget)
        if(!$(e.currentTarget).is(':button')){
          $button = $button.closest('button')
        }
        $button.blur()
        if(!_this.isOpen){
          _this.open()
        }else{
          _this.close()
        }
      })  
      
      this.closeCtrlr.click(function(e) {
        e.preventDefault()
        _this.close()  
      })  
    },
    
    open:function(){
      const _this = this
      $('body').addClass('body-masked')
      _this.isOpen = true
      _this.sidebar.fadeIn(100,function(){
        _this.container.addClass('wbsk-ui-sidebar__container--open')
      })
      var event = new CustomEvent('open' , {bubbles: true});
      event.wbskSideBar = this
      _this.sidebar[0].dispatchEvent(event);
    },
    
    close:function(){
      const _this = this
      $('body').removeClass('body-masked')
      _this.isOpen = false
      _this.sidebar.fadeOut(100,function(){
        _this.container.removeClass('wbsk-ui-sidebar__container--open')
      })
      var event = new CustomEvent('close' , {bubbles: true});
      event.wbskSideBar = this
      _this.sidebar[0].dispatchEvent(event);
    },
  }
  
  $.fn.wbskSideBar = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskSideBar', new wbskSideBar(this, settings))
    })
  }

}(jQuery, window));
